import { Controller } from "@hotwired/stimulus"

// 汎用モーダル（<dialog>）コントローラ。
// 使い方:
//   <div data-controller="modal">
//     <button type="button" data-action="modal#open">開く</button>
//     <dialog data-modal-target="dialog">
//       ...
//       <button type="button" data-action="modal#close">閉じる</button>
//     </dialog>
//   </div>
export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    if (event) event.preventDefault()
    if (this.hasDialogTarget) this.dialogTarget.showModal()
  }

  close(event) {
    if (event) event.preventDefault()
    if (this.hasDialogTarget) this.dialogTarget.close()
  }
}
